import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-largeScreen",
  "use": "icon-largeScreen-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-largeScreen\"><defs><style type=\"text/css\"></style></defs><path d=\"M921.6 870.4v102.4H102.4v-102.4h819.2zM1024 51.2v665.6H0V51.2h1024z m-102.4 102.4H102.4v460.8h819.2V153.6z\" p-id=\"790\" fill=\"#BFCBD9\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol